import React from 'react'

const CardsContainer = (props) => (
  <div className='section current-specials white'>
    <div className={`container content grey ${props.displayFourCards}`}>
      <div className={`row justify-content-around align-items-end card-row ${props.displayFourCards}`}>
        {props.children}
      </div>
    </div>
  </div>
);

export default CardsContainer;
